import { Component, ChangeDetectorRef } from '@angular/core';
import { DialogService } from '../../../services/core/dialog-service';

@Component({
    selector: 'loading-panel',
    templateUrl: './loading-panel.component.html'
})

export class LoadingPanelComponent {
    public loadPanelVisible: boolean = false;
    constructor(public dialogService: DialogService, public changeDetectorRef: ChangeDetectorRef) {
        this.dialogService.loadingPanelComponent = this;
    }
}